export default __webpack_public_path__ + "static/media/gameOver.c6590d77.mp3";